import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const WheelOffPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  maintenanceManagerContact,
  safetyOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Wheel_Off_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Wheel Off Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        To ensure safe and effective procedures for the removal, inspection, and replacement of vehicle wheels and tyres to maintain vehicle safety, compliance, and operational integrity.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all vehicles operated by {clientName || "the Company"}, including HGVs, PSVs, and company vehicles where wheel or tyre removal or replacement is required.
      </p>

      <h4 className="section-title">3. Authorisation and Competency</h4>
      <ul>
        <li>Only qualified and authorised personnel are permitted to remove, inspect, or replace wheels and tyres.</li>
        <li>Personnel must be trained and competent in safe wheel off procedures, tyre handling, torque settings, and inspection protocols.</li>
        <li>All wheel and tyre work must comply with manufacturer guidelines and relevant legal standards.</li>
      </ul>

      <h4 className="section-title">4. Procedures</h4>
      <ul>
        <li>Perform a full safety risk assessment before starting any wheel or tyre removal.</li>
        <li>Use appropriate lifting equipment and supports to ensure safe working conditions.</li>
        <li>Inspect wheels, tyres, wheel nuts, studs, and surrounding components thoroughly for defects or wear before replacement.</li>
        <li>Wheel nuts must be torqued to manufacturer specifications using calibrated torque tools.</li>
        <li>A re-torque check must be performed after initial wheel nut tightening following a minimum of 50 miles or as per manufacturer guidance.</li>
        <li>Attach a tamper-evident wheel or tyre tag to each wheel/tyre removed and replaced, indicating the date of service and technician's initials, to ensure traceability.</li>
        <li>Record all wheel off/on activities, inspections, torque readings, and maintenance actions in the vehicle's maintenance log.</li>
        <li>Do not return a vehicle to service unless all safety checks and documentation are complete.</li>
      </ul>

      <h4 className="section-title">5. Reporting and Follow-Up</h4>
      <p className="section-content">
        Any defects, irregularities, or safety concerns identified during wheel off or tyre replacement must be reported immediately to the Maintenance Manager and Safety Officer.
      </p>

      <h4 className="section-title">6. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Maintenance Manager:</strong> Oversees wheel off procedures, compliance, and record-keeping. Contact: {maintenanceManagerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Safety Officer:</strong> Monitors safety standards and investigates wheel/tyre related incidents. Contact: {safetyOfficerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Qualified Technicians:</strong> Responsible for safe wheel and tyre removal, inspection, replacement, and torqueing.</p>

      <h4 className="section-title">7. Record Keeping</h4>
      <p className="section-content">
        All wheel off and tyre maintenance activities must be logged and retained for auditing and compliance purposes, including torque records and tag details.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Wheel Off Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default WheelOffPolicy;
